<template>
    <v-text-field v-model="name" v-bind="{ readonly }" flat dense solo hide-details>
        <template #prepend-inner>
            <slot />
        </template>
        <template #append>
            <template v-if="!readonly">
                <v-btn small icon text @click="emit">
                    <v-icon>mdi-content-save</v-icon>
                </v-btn>
            </template>
            <v-btn small icon text @click="readonly = !readonly">
                <template v-if="readonly">
                    <v-icon>mdi-pencil</v-icon>
                </template>
                <template v-else>
                    <v-icon>mdi-close</v-icon>
                </template>
            </v-btn>
        </template>
    </v-text-field>
</template>

<script>
export default {
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        name: null,
        readonly: true,
    }),
    methods: {
        sync() {
            this.name = this.value;
        },
        emit() {
            this.$emit("input", this.name);
            this.readonly = true;
        },
    },
    watch: {
        value() {
            this.sync();
        },
        readonly() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.body-name {
    font-size: 16px;
}
</style>
